(function () {
  "use strict";

  var T = {
    de: {
      title: "Finde deine perfekte Gr\u00f6\u00dfe",
      modeQuestion: "Wie tanzt du?",
      competition: "Turnier",
      compSub: "Wettbewerb & Leistungstanz",
      compFit: "Fester Sitz",
      hobby: "Hobby / Social",
      hobbySub: "Freizeittanz & Social Dance",
      hobbyFit: "Komfortabler Sitz",
      modeHint:
        "Beide Varianten sind derselbe Schuh in derselben Weite. Unterschiedlich ist nur die empfohlene Gr\u00f6\u00dfe.",
      footLength: "Fu\u00dfl\u00e4nge eingeben",
      footPlaceholder: "z.B. 24,5",
      yourSize: "EU-Schuhgr\u00f6\u00dfe w\u00e4hlen",
      selectSize: "Gr\u00f6\u00dfe w\u00e4hlen\u2026",
      or: "ODER",
      recommend: "Deine empfohlene Gr\u00f6\u00dfe",
      size: "Gr\u00f6\u00dfe",
      fit: "Passform",
      shoeLength: "Innenl\u00e4nge",
      fitsRange: "F\u00fcr Fu\u00dfl\u00e4nge",
      noMatch:
        "F\u00fcr diese Gr\u00f6\u00dfe haben wir leider keine Empfehlung. Kontaktiere uns gerne f\u00fcr eine pers\u00f6nliche Beratung.",
      measureTip:
        "Miss deinen Fu\u00df von der Ferse bis zur l\u00e4ngsten Zehe.",
    },
    en: {
      title: "Find Your Perfect Size",
      modeQuestion: "How do you dance?",
      competition: "Competition",
      compSub: "Ballroom & competitive dance",
      compFit: "Snug fit",
      hobby: "Hobby / Social",
      hobbySub: "Recreational & social dance",
      hobbyFit: "Comfortable fit",
      modeHint:
        "Both options are the same shoe in the same width. Only the recommended size differs.",
      footLength: "Enter foot length",
      footPlaceholder: "e.g. 24.5",
      yourSize: "Select EU shoe size",
      selectSize: "Select size\u2026",
      or: "OR",
      recommend: "Your recommended size",
      size: "Size",
      fit: "Fit",
      shoeLength: "Inner length",
      fitsRange: "For foot length",
      noMatch:
        "No recommendation available for this size. Please contact us for personal advice.",
      measureTip: "Measure your foot from heel to longest toe.",
    },
  };

  var GIRTH_EN = {
    Schmal: "Narrow",
    Normal: "Normal",
    Breit: "Wide",
    "Leicht Breit": "Slightly Wide",
  };

  function translateGirth(girth, lang) {
    if (!girth || lang === "de") return girth;
    return girth.replace(
      /Schmal|Leicht Breit|Normal|Breit/g,
      function (m) { return GIRTH_EN[m] || m; }
    );
  }

  function fmtCm(val, lang) {
    var s = String(val);
    return lang === "de" ? s.replace(".", ",") : s;
  }

  /* ================================================================
     Saved state — persists across Shopify section re-renders.
     When variant click triggers a section re-render, the widget DOM
     is destroyed. We save state here so the MutationObserver can
     restore it when the widget reappears.
     ================================================================ */
  var saved = null;

  /* ================================================================
     Line item property tracking — injects hidden fields into the
     add-to-cart form so each line item carries its own size guide data.
     Underscore prefix hides properties from the customer.
     Persisted in lastTrackingData so it survives section re-renders.
     ================================================================ */
  var lastTrackingData = null;

  function findProductForm() {
    return document.querySelector(
      'form[data-type="add-to-cart-form"]:not([id*="--alt"])'
    );
  }

  function injectProps() {
    /* Inject into all add-to-cart forms (main + sticky cart) */
    var forms = document.querySelectorAll('form[data-type="add-to-cart-form"]');
    for (var f = 0; f < forms.length; f++) {
      var old = forms[f].querySelectorAll("input.ssw-prop");
      for (var i = 0; i < old.length; i++) old[i].remove();
      if (!lastTrackingData) continue;
      var input = document.createElement("input");
      input.type = "hidden";
      input.name = "properties[_Size Guide]";
      input.value = lastTrackingData;
      input.className = "ssw-prop";
      forms[f].appendChild(input);
    }
  }

  function setLineItemProperties(data) {
    lastTrackingData = data.mode + " | " + data.method + " " + data.input + " \u2192 " + data.recommended;
    injectProps();
  }

  function clearLineItemProperties() {
    lastTrackingData = null;
    var form = findProductForm();
    if (!form) return;
    var inputs = form.querySelectorAll("input.ssw-prop");
    for (var i = 0; i < inputs.length; i++) inputs[i].remove();
  }

  /* ---- init a single widget instance ---- */
  function initWidget(container) {
    if (container._sswInit) return;
    container._sswInit = true;

    var productTitle = container.dataset.productTitle;
    var locale = (container.dataset.locale || "de").substring(0, 2);
    var lang = T[locale] ? locale : "de";
    var t = T[lang];
    var gender = container.dataset.gender || "female";
    var hobbyIcon = gender === "male" ? "\uD83D\uDD7A" : "\uD83D\uDC83";
    var jsonUrl = container.dataset.jsonUrl;

    var product = null;
    var mode = "comp";
    var skipAutoSelect = false;

    /* ---- restore saved state if present ---- */
    if (saved) {
      mode = saved.mode || mode;
    }

    /* ---- render ---- */
    function render() {
      container.innerHTML =
        '<div class="ssw">' +
          '<div class="ssw-header">' +
            '<div class="ssw-hicon">' +
              '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
                '<path d="M21.3 15.3a2.4 2.4 0 0 1 0 3.4l-2.6 2.6a2.4 2.4 0 0 1-3.4 0L2.7 8.7a2.4 2.4 0 0 1 0-3.4l2.6-2.6a2.4 2.4 0 0 1 3.4 0l1.1 1.1-1.5 1.5 1.5 1.5 1.5-1.5 1.5 1.5-1.5 1.5 1.5 1.5 1.5-1.5 1.5 1.5-1.5 1.5 1.5 1.5 1.5-1.5z"/>' +
              '</svg>' +
            '</div>' +
            '<h3 class="ssw-title">' + t.title + '</h3>' +
          '</div>' +

          '<p class="ssw-mode-hint">' + t.modeHint + '</p>' +
          '<p class="ssw-mode-q">' + t.modeQuestion + '</p>' +
          '<div class="ssw-cards">' +
            '<button class="ssw-card-mode' + (mode === "comp" ? " ssw-card-on" : "") + '" data-mode="comp">' +
              '<span class="ssw-card-icon">\uD83C\uDFC6</span>' +
              '<span class="ssw-card-title">' + t.competition + '</span>' +
              '<span class="ssw-card-sub">' + t.compSub + '</span>' +
              '<span class="ssw-card-fit">' + t.compFit + '</span>' +
            '</button>' +
            '<button class="ssw-card-mode' + (mode === "hobby" ? " ssw-card-on" : "") + '" data-mode="hobby">' +
              '<span class="ssw-card-icon">' + hobbyIcon + '</span>' +
              '<span class="ssw-card-title">' + t.hobby + '</span>' +
              '<span class="ssw-card-sub">' + t.hobbySub + '</span>' +
              '<span class="ssw-card-fit">' + t.hobbyFit + '</span>' +
            '</button>' +
          '</div>' +


          '<div class="ssw-inputs">' +
            '<div class="ssw-ingrp">' +
              '<label class="ssw-lbl">' + t.yourSize + '</label>' +
              '<select class="ssw-sel" id="ssw-eu"><option value="">' + t.selectSize + '</option></select>' +
            '</div>' +
            '<div class="ssw-or"><span>' + t.or + '</span></div>' +
            '<div class="ssw-ingrp">' +
              '<label class="ssw-lbl">' + t.footLength + '</label>' +
              '<div class="ssw-fwrap">' +
                '<input type="text" class="ssw-inp" id="ssw-foot" placeholder="' + t.footPlaceholder + '" inputmode="decimal" autocomplete="off" maxlength="4">' +
                '<span class="ssw-unit">cm</span>' +
              '</div>' +
              '<p class="ssw-tip">' + t.measureTip + '</p>' +
            '</div>' +
          '</div>' +

          '<div class="ssw-result" id="ssw-result"></div>' +
        '</div>';

      populateDropdown();
      bindEvents();

      /* Restore input values + result after a section re-render */
      if (saved) {
        var footInput = container.querySelector("#ssw-foot");
        var euSelect = container.querySelector("#ssw-eu");
        if (footInput && saved.footValue) footInput.value = saved.footValue;
        if (euSelect && saved.euValue) euSelect.value = saved.euValue;

        // Restore scroll position
        var sy = saved.scrollY;
        requestAnimationFrame(function () { window.scrollTo(0, sy); });

        // Recalculate to show the result again, but do NOT re-trigger variant click
        skipAutoSelect = true;
        recalculate();
        skipAutoSelect = false;

        // Re-inject tracking props into the new form after section re-render
        if (lastTrackingData) injectProps();

        saved = null;
      }
    }

    /* ---- dropdown ---- */
    function populateDropdown() {
      var select = container.querySelector("#ssw-eu");
      if (!select || !product) return;
      var sv = select.value;
      var map = product[mode] || {};
      var sizes = Object.keys(map).sort(function (a, b) { return parseFloat(a) - parseFloat(b); });
      var html = '<option value="">' + t.selectSize + '</option>';
      for (var i = 0; i < sizes.length; i++) {
        html += '<option value="' + sizes[i] + '"' + (sizes[i] === sv ? ' selected' : '') + '>' + sizes[i] + '</option>';
      }
      select.innerHTML = html;
    }

    /* ---- foot range for a given SOUL size (midpoint between neighbours) ---- */
    function getFootRange(orderSize) {
      if (!product || !product.lengths) return null;
      var entries = Object.entries(product.lengths).sort(function (a, b) { return a[1] - b[1]; });
      for (var i = 0; i < entries.length; i++) {
        if (entries[i][0] === orderSize) {
          var cur = entries[i][1];
          var min, max;
          if (i > 0) {
            min = Math.round((entries[i - 1][1] + cur) / 2 * 10) / 10;
          } else {
            var gapNext = entries.length > 1 ? entries[1][1] - cur : 0.5;
            min = Math.round((cur - gapNext / 2) * 10) / 10;
          }
          if (i < entries.length - 1) {
            max = Math.round((cur + entries[i + 1][1]) / 2 * 10) / 10;
          } else {
            var gapPrev = i > 0 ? cur - entries[i - 1][1] : 0.5;
            max = Math.round((cur + gapPrev / 2) * 10) / 10;
          }
          return { min: min, max: max };
        }
      }
      return null;
    }

    /* ---- show result ---- */
    function showResult(orderSize, fittingSize) {
      var el = container.querySelector("#ssw-result");
      if (!el || !product) return;

      if (!orderSize) {
        el.innerHTML = '<div class="ssw-nomatch">' + t.noMatch + '</div>';
        el.className = "ssw-result ssw-result-show";
        return;
      }

      var girth = translateGirth(product.g, lang);
      var range = getFootRange(fittingSize || orderSize);
      var rangeStr = range ? fmtCm(range.min, lang) + " \u2013 " + fmtCm(range.max, lang) + " cm" : null;

      var detailParts = [];
      if (girth) detailParts.push(t.fit + ': ' + girth);
      if (rangeStr) detailParts.push(t.fitsRange + ' ' + rangeStr);
      var detailStr = detailParts.join(' · ');

      el.innerHTML =
        '<div class="ssw-card">' +
          '<div class="ssw-card-top">' +
            '<div class="ssw-badge">' + orderSize + '</div>' +
            '<div class="ssw-card-info">' +
              '<div class="ssw-rec">' + t.recommend + '</div>' +
              (detailStr ? '<div class="ssw-detail">' + detailStr + '</div>' : '') +
            '</div>' +
          '</div>' +
        '</div>';

      el.className = "ssw-result ssw-result-show";

      /* Track size guide usage as line item properties */
      if (!skipAutoSelect) {
        var footInput = container.querySelector("#ssw-foot");
        var cmVal = footInput ? footInput.value.trim() : "";
        setLineItemProperties({
          mode: mode === "comp" ? "Competition" : "Hobby",
          method: cmVal ? "Foot Length" : "EU Size",
          input: cmVal ? cmVal + " cm" : (container.querySelector("#ssw-eu") || {}).value || "",
          recommended: orderSize
        });
      }

      /* Auto-select the variant — unless we are restoring after a re-render */
      if (!skipAutoSelect) {
        selectVariantOnPage(orderSize);
      }
    }

    /* ---- select variant in the theme's size picker ---- */
    function selectVariantOnPage(soulSize) {
      var size = String(soulSize);

      /* Save widget state BEFORE the click triggers a section re-render */
      var footInput = container.querySelector("#ssw-foot");
      var euSelect = container.querySelector("#ssw-eu");
      saved = {
        mode: mode,
        footValue: footInput ? footInput.value : "",
        euValue: euSelect ? euSelect.value : "",
        scrollY: window.scrollY
      };

      // Strategy 1: Radio inputs (Shopify 2.0 themes)
      var radios = document.querySelectorAll(
        'variant-picker input[type="radio"], ' +
        'variant-radios input[type="radio"], ' +
        '.variant-picker input[type="radio"], ' +
        '.product-form input[type="radio"]'
      );
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].value === size) {
          var label = document.querySelector('label[for="' + radios[i].id + '"]');
          if (label) { label.click(); } else { radios[i].click(); }
          return;
        }
      }

      // Strategy 2: Clickable labels/buttons with matching text
      var clickables = document.querySelectorAll(
        'variant-picker label, variant-radios label, ' +
        '.variant-picker label, .variant-picker button'
      );
      for (var i = 0; i < clickables.length; i++) {
        if (clickables[i].textContent.trim() === size) {
          clickables[i].click();
          return;
        }
      }

      // Strategy 3: Select dropdowns
      var selects = document.querySelectorAll(
        'variant-picker select, .variant-picker select, .product-form select'
      );
      for (var i = 0; i < selects.length; i++) {
        for (var j = 0; j < selects[i].options.length; j++) {
          var opt = selects[i].options[j];
          if (opt.value === size || opt.textContent.trim() === size) {
            selects[i].value = opt.value;
            selects[i].dispatchEvent(new Event('change', { bubbles: true }));
            return;
          }
        }
      }

      // Strategy 4: Data-attribute swatch buttons
      var swatches = document.querySelectorAll('[data-option-value], [data-value]');
      for (var i = 0; i < swatches.length; i++) {
        var val = swatches[i].dataset.optionValue || swatches[i].dataset.value;
        if (val === size) {
          swatches[i].click();
          return;
        }
      }

      // No match found — clear saved state (no re-render will happen)
      saved = null;
    }

    /* ---- clear result ---- */
    function clearResult() {
      var el = container.querySelector("#ssw-result");
      if (el) {
        el.innerHTML = "";
        el.className = "ssw-result";
      }
      clearLineItemProperties();
    }

    /* ---- find size by foot length (midpoint ranges, same as getFootRange) ---- */
    function findByFootLength(val) {
      if (!product || !product.lengths) return null;
      var target = parseFloat(String(val).replace(",", "."));
      if (isNaN(target)) return null;

      var entries = Object.entries(product.lengths).sort(function (a, b) { return a[1] - b[1]; });
      if (entries.length === 0) return null;

      var fittingSize = null;
      for (var i = 0; i < entries.length; i++) {
        var cur = entries[i][1];
        var lo, hi;
        if (i > 0) {
          lo = (entries[i - 1][1] + cur) / 2;
        } else {
          var gN = entries.length > 1 ? entries[1][1] - cur : 0.5;
          lo = cur - gN / 2;
        }
        if (i < entries.length - 1) {
          hi = (cur + entries[i + 1][1]) / 2;
        } else {
          hi = cur + 1.0;
        }
        if (target >= lo && target <= hi) { fittingSize = entries[i][0]; break; }
      }
      if (!fittingSize) return null;

      if (mode === "comp") return { recommended: fittingSize, fitting: fittingSize };

      /* Hobby: direct fh lookup (no comp/hobby map involvement) */
      var fhMap = product.fh || {};
      var hobbyRec = fhMap[fittingSize];
      return { recommended: hobbyRec || fittingSize, fitting: fittingSize };
    }

    /* ---- recalculate ---- */
    function recalculate() {
      var footInput = container.querySelector("#ssw-foot");
      var euSelect = container.querySelector("#ssw-eu");
      var cmVal = footInput ? footInput.value.trim() : "";
      var euVal = euSelect ? euSelect.value : "";

      if (cmVal) {
        var result = findByFootLength(cmVal);
        if (result) {
          showResult(result.recommended, result.fitting);
        } else {
          showResult(null);
        }
        return;
      }

      if (euVal) {
        var map = product[mode] || {};
        showResult(map[euVal] || null);
        return;
      }

      clearResult();
    }

    /* ---- bind events ---- */
    function bindEvents() {
      var btns = container.querySelectorAll(".ssw-card-mode");
      btns.forEach(function (btn) {
        btn.addEventListener("click", function () {
          mode = btn.dataset.mode;
          btns.forEach(function (b) { b.classList.remove("ssw-card-on"); });
          btn.classList.add("ssw-card-on");
          populateDropdown();
          recalculate();
        });
      });

      var euSelect = container.querySelector("#ssw-eu");
      if (euSelect) {
        euSelect.addEventListener("change", function () {
          var footInput = container.querySelector("#ssw-foot");
          if (footInput && euSelect.value) footInput.value = "";
          recalculate();
        });
      }

      var footInput = container.querySelector("#ssw-foot");
      if (footInput) {
        /* Allow only digits + one comma/dot, max format: DD,D (e.g. 25,3) */
        footInput.addEventListener("input", function () {
          var v = footInput.value;
          /* strip anything that isn't digit, dot, or comma */
          v = v.replace(/[^\d.,]/g, "");
          /* keep only the first separator */
          var sep = v.search(/[.,]/);
          if (sep !== -1) {
            var before = v.slice(0, sep).replace(/[.,]/g, "");
            var after = v.slice(sep + 1).replace(/[.,]/g, "");
            v = before + v[sep] + after;
          }
          /* max 2 digits before separator, 1 after */
          var parts = v.split(/[.,]/);
          if (parts[0].length > 2) parts[0] = parts[0].slice(0, 2);
          if (parts.length > 1 && parts[1].length > 1) parts[1] = parts[1].slice(0, 1);
          v = parts.length > 1 ? parts[0] + (lang === "de" ? "," : ".") + parts[1] : parts[0];
          if (v !== footInput.value) footInput.value = v;
        });

        var timer;
        footInput.addEventListener("input", function () {
          clearTimeout(timer);
          timer = setTimeout(function () {
            var sel = container.querySelector("#ssw-eu");
            if (sel && footInput.value.trim()) sel.value = "";
            recalculate();
          }, 400);
        });
      }
    }

    /* ---- data loading ---- */
    function loadData() {
      if (window.__soulSizeData) {
        onData(window.__soulSizeData);
        return;
      }
      if (jsonUrl) {
        fetch(jsonUrl)
          .then(function (r) { return r.json(); })
          .then(function (d) { window.__soulSizeData = d; onData(d); })
          .catch(function () { container.style.display = "none"; });
      } else {
        container.style.display = "none";
      }
    }

    function onData(data) {
      product = data[productTitle];
      if (!product) { container.style.display = "none"; return; }
      render();
    }

    loadData();
  }

  /* ================================================================
     Bootstrap: init now + watch for DOM changes (section re-renders)
     ================================================================ */
  function tryInit() {
    var el = document.getElementById("soul-size-widget");
    if (el && !el._sswInit) {
      initWidget(el);
    }
  }

  function startObserver() {
    var observer = new MutationObserver(function (mutations) {
      var needsInject = false;
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) {
          var el = document.getElementById("soul-size-widget");
          if (el && !el._sswInit) {
            initWidget(el);
            return;
          }
          needsInject = true;
        }
      }
      /* Re-inject tracking props if the form was rebuilt by a section re-render */
      if (needsInject && lastTrackingData) {
        var form = findProductForm();
        if (form && !form.querySelector("input.ssw-prop")) {
          injectProps();
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      tryInit();
      startObserver();
    });
  } else {
    tryInit();
    startObserver();
  }
})();
